import { C as CosmosBadge$1, d as defineCustomElement$1 } from './p-7ca5e297.js';

const CosmosBadge = CosmosBadge$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosBadge, defineCustomElement };
